import swal from "sweetalert"
import * as Sentry from "@sentry/browser"

import {
    loadDefaultOrganizationDesign,
    saveNewPDFEmailForSearchDownloads,
    saveNewTemplate,
} from "app/static/frontend/search-new/containers/Downloads/action-creators"
import { createSearchRequestStore } from "app/static/frontend/search-new/containers/Downloads/helperFunctions"
import { EMAIL_DOWNLOAD_SWAL_JSON, EMAIL_DOWNLOAD_SWAL_JSON_DOCUMENTS } from "shared/imports/sharedConstants"

/**
 * Given relevant information about the search request and possible additional info about
 * profileId and templateType, create a new template that will handle the search pdf request.
 *
 * @param {Number} filterQdt - qdt of the inline element to load
 * @param {Object} filters - associated filters to load for the inline element.
 * @param {Number} filterElementCount - size of the searchify set
 * @param {object} profileId - optional profileId to provide if template is not a blank download.
 * @param {object} templateType - optional templateType to provide, else it will be a blank download.
 */
export const createNewTemplateFromSearch =
    ({
        filterQdt,
        filters,
        filterElementCount,
        isDocumentDownload = false,
        profileId,
        templateName,
        templateType = DjangIO.app.pdfdownload.types.NewDownloadTemplateType.auto_generated.value,
    }) =>
    async (dispatch) => {
        try {
            let name = templateName
            if (!templateName) {
                const downloadName = isDocumentDownload
                    ? await swal(EMAIL_DOWNLOAD_SWAL_JSON_DOCUMENTS)
                    : await swal(EMAIL_DOWNLOAD_SWAL_JSON)
                if (downloadName === null) {
                    // user cancelled the download
                    return false
                }
                if (downloadName === "") {
                    swal("Error", "Please enter a name.", "error")
                    return false
                }
                if (downloadName.length > 160) {
                    swal("Error", "The title of this download is too long.", "error")
                    return false
                }
                name = downloadName
            }
            if (name.length > 160) {
                name = name.substr(0, 160)
            }
            const defaultOrgDesign = await dispatch(loadDefaultOrganizationDesign())
            const profileQdt = DjangIO.app.models.QuorumDataType.blank_download.value
            const store = createSearchRequestStore({
                profileQdt,
                defaultOrgDesign,
                filterQdt,
                filters,
                filterElementCount,
                downloadName: name,
            })
            const newTemplate = await dispatch(saveNewTemplate({ name, store, templateType, profileId }))
            await dispatch(saveNewPDFEmailForSearchDownloads({ name, newTemplate }))
            swal("Success!", "Check your inbox in the next few minutes for a link.", "success")
        } catch (error) {
            console.error(error)
            Sentry.captureException(error)
        }
    }
